import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import Fontawesome from 'react-fontawesome';

export default ({ CalltoAction, waypoint }) => (
  <Button>
    <Link
      to="contact"
      spy
      smooth
      duration={500}
      style={{
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white'
      }}
      activeClass="active-nav"
      offset={-50}
    >
      {CalltoAction}
      <Fontawesome name="chevron-circle-right" style={{ marginLeft: 10 }} />
    </Link>
  </Button>
);

const Button = styled.button`
  width: 250px;
  height: 60px;
  background: #4babc0;
  background: #667db6; /* fallback for old browsers */
  background: linear-gradient(to right, #4babc0, #0082c8);
  font-size: 25px;
  line-height: 25px;
  margin-top: 25px;
  color: white;
  display: flex;
  justify-content: center;
  border-radius: 35px;
  align-items: center;
  cursor: pointer;
  border: none;
  transition: 0.5s ease-out;
  &:focus {
    outline: none;
    border: none;
  }
  &:hover {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  }
`;



// WEBPACK FOOTER //
// ./src/components/Title/components/callToAction.js